import st from "@/styles/Ui.module.scss";
import Countdown, {CountdownRenderProps} from "react-countdown";
import Button from "@/ui/Button.tsx";
import clsx from "clsx";
import CircleArrow from "@/svg/CircleArrow.tsx";
import React, {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAtom} from "jotai/index";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";

interface Props {
    onClick():void
    interval_atom: any
    className?:string
}

const ResendCounter:React.FC<Props> = (props) => {
    const { onClick, interval_atom, className } = props
    const {t} = useTranslation()
    const [interval, set_interval] = useAtom(interval_atom)
    const [countEnd, setCountEnd] = useState(false)
    
    
    const getInterval = ():any => {
        if(interval) {
            const d = JSON.parse(interval as string)
            
            return d?.interval
        } else {
            return 0
        }
    }
    
    const target_date = new Date(getInterval())
    
    const set_count_end_handler = useCallback((x: boolean) => {
        setCountEnd(x);
    }, [setCountEnd]);
    
    const countDownCompleteHandler = () => {
        set_interval("")
        setCountEnd(true);
    }
    
    useEffect(() => {
        
        eventEmitter.on(CommonClass.CustomEvents.set_resend_interval, set_count_end_handler)
        
        return () => {
            eventEmitter.off(CommonClass.CustomEvents.set_resend_interval, set_count_end_handler)
        }
        
    }, [set_count_end_handler]);
    
    return (
        <div className={clsx(st.cd, className && className)}>
            
            <div className={st.cd_mobile}>
                {(!countEnd && target_date) && (
                    <>
                        {t("resend_in")}
                        
                        <Countdown
                            date={target_date}
                            renderer={(args) => renderer({...args})}
                            intervalDelay={1000}
                            zeroPadTime={2}
                            onComplete={countDownCompleteHandler}
                        />
                    </>
                )}
            </div>
            
            <Button
                className={clsx(st.resend_btn)}
                onClick={onClick}
                type={"button"}
                dark
                disabled={!countEnd}
            
            >
                <div style={countEnd ? {justifyContent: "center"} : {}} className={st.btn_content}>
                    
                    {(!countEnd && target_date) && (
                        <>
                            <span>
                                {t("resend_in")}
                            </span>
                            
                            <Countdown
                                date={target_date}
                                renderer={(args) => renderer({...args})}
                                intervalDelay={1000}
                                zeroPadTime={2}
                                onComplete={countDownCompleteHandler}
                            />
                        </>
                    )}
                    
                    <div>
                        <CircleArrow/>
                        
                        {t("resend_code")}
                    </div>
                
                </div>
            
            </Button>
        
        </div>
    )
}

const renderer = (args: CountdownRenderProps) => {
    const {minutes, seconds} = args;
    const padValue = (value: number) => (value < 10 ? `0${value}` : `${value}`);
    
    return (
        <div>
            {padValue(minutes) || "00"} :
            {" "+padValue(seconds) || " 00"}
        </div>
    );
    
};

export default ResendCounter